import React from "react"
import { useLocation, matchPath } from "react-router-dom"

/**
 * Показывает содержимое, когда адрес страницы совпадает с шаблоном.
 *
 * В react-router 5 для этого ставили `<Route path={...}>…</Route>` прямо посреди
 * разметки. В шестой версии `<Route>` живёт только внутри `<Routes>` и ничего
 * не рисует сам по себе, поэтому условие вынесено в отдельный компонент.
 *
 * Совпадение неполное (`end: false`) — как у `<Route>` без `exact` в пятой версии:
 * шаблон «/spending/departments/:id» подходит и для более длинного адреса.
 */
export const WhenPath: React.FC<WhenPathProps> = ({ path, children }) => {
    const location = useLocation()
    const match = matchPath({ path, end: false }, location.pathname)

    return match ? <>{children}</> : null
}

interface WhenPathProps {
    path: string
    children?: React.ReactNode
}
